import {HttpClient} from "../../service/httpClient/HttpClient";

export class DashboardService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getDashboardInfo() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/dashboard-information`,
            ).then(resolve).catch(reject)
        })
    }

    getFundsStatusList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }
}